module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CHAPTER TWO")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Saturday, June 28, 1902"), _c('br'), _vm._v(" 12:00 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ICK")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RAGG STARED")])]), _vm._v(" at his Victorian home, the engine of the Daimler idling, but he did not really see the quaint brick house. Instead, the interview he’d just had with Francesca kept replaying in his mind. He was very afraid for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He knew Hart would eventually destroy her. His brother had a black, selfish soul. He was cruel and self-involved. From time to time he could rise to the occasion, briefly showing the honorable side of his nature, but in the end, he always reverted to serving only his own interests and ambitions. Francesca was selfless. Hart was selfish. No match could be worse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("But he was hardly an impartial observer. Bragg was afraid to recall the past he had shared with Francesca. He feared that too many old feelings would return. He knew he must not think of the time they had first met, when he had been smitten with her—and she had returned his passionate interest. He must not think about their debates, their discussions, their investigations—or the kisses and caresses they had shared. That was wrong. His wife had returned after leaving him four years ago, and as uneasy as it was, as angry as he had been, they had reconciled. Besides, before Francesca had become charmed by his brother, she had utterly rejected the notion of his ever ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("divorcing. Although he never spoke openly about it, in the most elite political circles it was assumed that one day he would run for office, possibly even for the United States Senate. A divorce would ruin his political prospects.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had made his own bed, which he now slept in. Leigh Anne had insisted on moving back in with him—and when she had, he had insisted on his marital rights. He had been furious with her for both leaving him and then returning to him. What had begun as an unfriendly reconciliation had turned into a passionate one, but his lust had been fed by his anger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had spent half of last night working, the other half thinking about the fact that Francesca was actually going to marry his heartless half brother on the morrow. He did not know where the past few weeks had gone. He had been overwhelmed at headquarters. There had been a series of civilian arrests in the Tenderloin—organized, of course, by the radical reformer Reverend Parkhurst, whose motives were political. Parkhurst vociferously claimed it was his duty as an American citizen to do what the police would not, which was to close the saloons on Sundays, while the press sensationalized every detail of every civilian raid, putting Bragg in the midst of the dispute. The mayor was furious with Parkhurst, but he was also displeased with Bragg. And Leigh Anne had begun to complain of pains in her leg.…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then he had received the damn wedding invitation, only a week ago!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was certain he could support Francesca’s marriage to someone else—someone worthy of her. Hart was not that man. But what could he do? He had tried to persuade her to delay, and she had refused. Now, he would have to stand aside and be ready to pick her up when Hart shattered her into tiny pieces. Bragg had not a doubt that was what his half brother would do.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He realized that the automobile was still running and he turned off the ignition. Reluctantly, he got out of the roadster, placing his goggles on the driver’s seat. The holiday weekend loomed. He would take his wife and the two girls fostering with them to the tiny village hamlet of Sag Harbor, on Long Island’s north shore. He had spent all of the prior night at his office at police headquarters, taking care of paperwork that only he could manage—the perfect excuse to stay overnight at the office. It wasn’t the first time; he had begun keeping a change of clothing there. He was astute enough to realize that he dreaded returning home. He wasn’t sure when he had begun to avoid his marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The anger was long gone. It had been replaced by guilt. He had treated Leigh Anne terribly before she was injured. While she did not blame him for the accident, he blamed himself. His cruelty had put her in such a state of distraction that she had been run down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As for the lust, every time he thought about reaching for her, she would turn away, or feign sleep, or make some excuse that one of the girls was awake, needing her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was hardly a fool. Leigh Anne was a passionate woman, but she was also vain and she couldn’t stand the changes the accident had wrought in her body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had even told him to take a mistress; she had even asked for a divorce. How ironic it was. He had been the one who had wanted a divorce when she suddenly reappeared in his life in February, while she had insisted on reconciliation! He wondered what was left for them, if they didn’t have conversation, understanding, affection or sex. He would never turn his back on her now. Even if he knew rationally that the accident wasn’t really his fault, she was his wife. If he didn’t take care of her, who would?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("He walked grimly past a small black gig and gray ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("horse parked in the driveway. He instantly recognized the vehicle, and his tension increased. Leigh Anne must have summoned Dr. Finney.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He focused on the fact that she must be in more pain—it was preferable to thinking about their volatile and unhappy relationship. He started up the brick path to the small house he had leased, hoping the girls were in the park with their nanny so they would not witness Leigh Anne’s distress. He stepped into the house, plastering a smile on his face. Instantly he heard a noise on the stairs. Katie came barreling down the staircase so swiftly he reached for her, afraid she would trip and fall. Her small face was taut with worry. His heart lurched with dismay.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He knelt. “What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mrs. Bragg hurts so much,” she cried, looking at him as if he might be able to somehow save the day. She was dark haired and seven years old.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Katie was always anxious. When she came to them after her mother’s murder, she had refused to speak or eat. Now she spoke, although not frequently, and ate like a little horse. She even smiled from time to time, especially when Leigh Anne was at her best and mothering her. But she worried about her foster mother all the time and he knew it was not healthy for her. He clasped her thin shoulders. “Katie, Mrs. Bragg was badly hurt in that carriage accident. Now and then, she will have some old pain, left over from her injuries.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why won’t it stop?” she whispered, her dark eyes huge and despairing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She has her good days, too. I am going to go upstairs to see what Dr. Finney has to say. Where is Dot?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She is having lunch.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why don’t you join her. Aren’t you hungry? Mrs. Flowers is a wonderful cook.” He managed a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Katie did not smile back, but she reluctantly turned. He hurried upstairs, his heart racing. Amazingly, he was anxious. He paused on the threshold of their bedroom, wondering how a man could live this way—in dread of going home, to a place without laughter and affection, without sex; in a state of constant apprehension. And then there was the guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leigh Anne wasn’t dressed yet. She wore a modest blue silk wrapper, her jet-black hair piled indifferently atop her head. She had the covers up and a wool throw over her lap, as if she was cold. Finney sat by the bed, speaking with her, patting her hand. His wife remained terribly beautiful, but she appeared as fragile as china.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leigh Anne saw him and sat up straighter, as if stiffening her spine and squaring her shoulders. He slowly entered the room. “How are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She said, “The pain is worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. Finney walked over. The two men shook hands. The doctor spoke softly. “I have given her some laudanum, to dose herself at night. She says she cannot sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There is nothing wrong with her leg,” Bragg said tersely. “Those broken bones have healed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Considering there was so much damage, I suspect she will always have some discomfort with her right leg. Try to make sure she does not rely on the laudanum to sleep. She should only dose herself if absolutely necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll see to it,” Bragg said. “Let me walk you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can manage.” Finney gripped his shoulder. “See you later, eh? At Hart’s wedding?” He shook his head, as if in disbelief, and walked out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Slowly, Bragg turned.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I heard every word,” Leigh Anne said, her cheeks flushed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am sorry you are in pain,” he returned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where are the girls?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was aware of how much she had come to love Katie and Dot. He wondered if she was desperately clinging to them. “They are having lunch.” He approached, and her eyes widened. As he sat down on the bed by her hip, she tensed visibly, and he wondered if she thought he meant to try to make love to her. In that moment, there was no desire, just a fatigue that felt ancient.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he knew himself. If she were to reach for him, he would lose himself in lust. He said carefully, “It’s after one. Shouldn’t you be getting dressed?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hesitated. “I do not feel up to the wedding.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was shocked. Leigh Anne loved society affairs, and although it was late June, this event would be in every single social column from Bar Harbor to Charleston. He thought about the fact that she hadn’t gone out in the past few days, not even to be pushed about the block or across the square in her wheelchair. When they had first met, she had been one of Boston’s reigning debutantes. Until recently, Leigh Anne had attended almost every luncheon to which she had been invited. She had been at his side at every supper party and charity she had deemed important to his career. He understood that she was melancholy, but it would only become worse if she did not get out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She grimaced. “Of course I will come. And you’re right, I should begin getting dressed. Where is Nanette?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had had to hire a lady’s maid to help her bathe and dress. As his finances were precarious, he had let the male nurse go. “I will send her up,” he said as lightly as possible.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("She forced a smile, avoiding his eyes. He went to the door. Then he halted. He hated seeing her so despondent. ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("But how could he cheer her up? Maybe he should tell her that she did not have to go to the wedding if she truly did not feel well. Bragg turned.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leigh Anne was pouring brandy from a pint-size bottle into her cup of tea.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RANCESCA HAD BECOME")]), _vm._v(" very familiar with many of the unsavory, crime-ridden lower wards of Manhattan. Still, it was a large city, filled with slums and tenements, factories and saloons, with neighborhoods populated by Germans, Italians and Irish, not to mention Russians, Poles and Jews. In the course of her many adventures, she had even learned that there was a “Little Africa” on the Lower East Side. The various immigrant groups migrating to the city resided in distinct ethnic clusters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was proud that she knew the city well, but she did not know it like the back of her hand. In her very first investigation—into the abduction of a neighbor’s child—she had met a young, outspoken cutpurse, eleven-year-old Joel Kennedy. He had defended her from a thug, and she had taken him under her wing, not just because he knew so many tricks of the trade, but because she had a secret wish to help him improve his lot in life. When she did not have Joel with her—a rare circumstance indeed—she used a map to navigate Manhattan. Today, Joel was with his mother, Maggie, a wonderful seamstress who had become her friend—and possibly a romantic interest of her brother’s. She could imagine the chaos in the Kennedy home just then, as Maggie had been stunned to have been invited to her wedding. Undoubtedly Joel and his siblings were being groomed for the event.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she did not need her maps. The cabbie she flagged down on the avenue instantly told her that No. 69 Waverly Place was on the north side of Washington Square.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("Francesca was relieved. The previewing was but a few ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("blocks from 300 Mulberry Street—which housed police headquarters.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was on pins and needles. She had not a doubt in her mind that her portrait was at No. 69 Waverly Place. She had begun to wonder if someone wished to agitate her on her wedding day. If so, that someone had certainly succeeded!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Earlier, she had been relieved to find her father’s study empty; perhaps Andrew had been taking his weekend ambulatory in the park. She had made one quick telephone call before leaving the house, and it would have been quicker if the operator, Beatrice, hadn’t tried to converse with her about her wedding. But Hart hadn’t been home—she couldn’t imagine what he was doing on their wedding day—and she had spoken to his butler, Alfred. The butler had asked her if she wished to leave a message, but she had been too frenzied to get downtown to think of anything coherent to say. Before dashing out of the house, Connie had told her that she was a madwoman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca looked at the small pocket watch she had bought for herself recently; crime-solving was laborious, and she tended to run late. It was half past one. It had taken longer to get downtown than she had thought it would, but she had a good hour yet to explore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They were on Fifth Avenue, traveling south. Ahead, she saw the green lawns and paved walkways of Washington Square. On both sides of Fifth Avenue she saw old brownstone buildings that were clearly residences, although she also saw a few ground-floor restaurants and taverns. Her hansom turned left onto Waverly Place, which faced the square. More dark brownstones lined the block, shaded by elm trees. Shops were on the lower floors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She caught the bright sign hanging from one such establishment: Gallery Moore.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stop, driver, stop!” Her gaze sought the number above the sign. It was No. 69.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frantically, Francesca dug into her purse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you want me to wait, miss?” the cabbie asked. He had a heavy Italian accent.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca quickly looked around. Despite the holiday, the square was full. Women in pretty cotton dresses, some with parasols, were strolling with their children or their gentlemen escorts. Some of the men were in their shirtsleeves, while a few wore suit jackets and top hats. Two cyclists, one a woman in knickers, were on bicycles, weaving precariously along the paths. A few small dogs raced about, while a balloon drifted into the sky. It was a very pleasant, genteel scene.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked at the block facing her. Once, the buildings had been fashionable, single-family Georgian homes. There were daffodils growing about the elm trees on the sidewalks, and she saw more flowers in the window boxes. Washington Square was a tired and old neighborhood, but it remained middle-class. Another hansom was passing by and she decided it was safe to let the cabdriver go.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was in such a rush that she stumbled from the cab. Slamming the door, she turned to face the gallery. Her heart thundered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Everyone seemed to be in the square; the city block was deserted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She paused to take her small pistol from her purse. It was loaded. Whoever had stolen her portrait, he or she was, at the least, a thief. And she would certainly not be surprised if that thief was also a blackmailer or an enemy, seeking revenge upon her. She would be a fool to deny her fear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her stolen portrait could be inside. She prayed that it was.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("There were wide stone steps on her right, leading to the ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("apartments above the gallery. The gallery itself was on the basement level, meaning she had to go down several steps to get to the front door. As she did, the first thing she saw was the white sign hanging on the door. Its bold black letters read Closed.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She paused, clutching the small gun. The door was glass, but set in iron and barred with it. She glanced at the windows on each side, which were similarly barred. Most galleries had large windows, to allow in natural light. She imagined that it was dark and gloomy inside this space.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A smaller sign was in the right-hand window. She went closer to read it.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_vm._v("Summer Hours: Monday-Friday, 12:00–5:00 p.m.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The gallery was closed to the public. Francesca felt her heart leap with relief, but that did not dim her anxiety. A small doorbell was beside the door, and there was a heavy iron knocker on it. Francesca reached for the doorknob.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It gave instantly as she turned it, and the front door swung open.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clearly, someone was waiting for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In that moment, she wished that Hart had been at home, or that Bragg had still been present when she had gotten the invitation. She blinked, adjusting her eyes to the gloom inside. No lights were on, so the gallery was filled with shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca stepped in and closed the door behind her very, very quietly. To her satisfaction, she did not hear even the scrape of iron on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She could see well enough now and she turned, her skin beginning to prickle, certain she was not alone. She almost gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her portrait faced her.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She trembled. She had forgotten how stunning the painting was—and how provocative. In it, she wore nothing but a pearl choker. Her hair was up and perfectly coiffed. She sat with her back to the viewer, but she was partially turned. Not only were most of her buttocks visible, so was the entire profile of one of her breasts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no mistaking her identity—and to make matters worse, she wore an expression of naked sensuality and raw hunger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she had posed for that painting, all she could think about was Hart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her instinct was to rush forward and yank the picture from the wall and destroy it. But there would be time for that later. She fought for composure. What did the thief want? Why surface now? Did he or she want money? Did he or she want to ruin her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was she being watched?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She felt as if eyes were upon her—and she did not like it, not one damn bit. She had her back to the door. She looked outside through the bars and glass, but the small concrete space beyond the front door was vacant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca started forward, gun in hand. If the thief was watching her, there was no point in remaining silent. Now she saw the other paintings on the walls. None were Sarah Channing’s work. Her style, somewhat classical yet impressionistic, too, was very distinct. “Where are you?” she called out loudly, turning the corner behind the center wall. The area there boasted nothing but blank gray walls. “Who are you? What do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her words seemed to echo slightly in this smaller back chamber. She saw an open doorway, but hesitated. “Come out. I know you’re here.” She swallowed, straining to listen. All she could hear was her own thundering heartbeat and her rapid, shallow breathing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("She was afraid. Why wouldn’t she be? Someone had ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("lured her to that gallery. She needed to take possession of that painting. “I will pay you handsomely for my portrait!” she cried.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Standing in the back room, facing a dark, open doorway, she knew a moment of despair. What kind of game was this?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hated releasing her gun, but she tucked it in the waistband of her skirt, only so she could remove matches and a candle from her purse. Months ago, she had learned to carry a large bag in order to keep the necessities of her trade with her. She lit the candle and realized the small doorway belonged to a single room, which consisted of a desk, a chair and file cabinets.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca walked inside and saw nothing but receipts and notes on the desk. She looked carefully at the notes, but they were scribbles. Neither her name nor Hart’s jumped out at her. She looked at the saucer, which contained business cards.")]), _vm._v(" "), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Gallery Moore—Fine Arts and Consignments"), _c('br'), _vm._v(" Owned by Daniel Moore"), _c('br'), _vm._v(" No. 69 Waverly Place,"), _c('br'), _vm._v(" New York, NY")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She rummaged through the drawers quickly, but there was simply too much paperwork to go through when the clock was ticking. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The time.")]), _vm._v(" She froze, then reached for her purse, which she had laid on the desk. It was almost half past two.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her temples throbbed. She did not have time to investigate now. But Bragg would be at her wedding and she would tell him everything before the ceremony, and send him downtown to retrieve the painting. But how could she leave the portrait now?")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What did the damn thief truly want?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca snuffed out the candle with her fingertips and left it on the desk—she had others in her purse. She took her gun from the waistband of her skirt. Purse in hand, in the darkness, she left the small office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She thought she heard a small scraping sound coming from the front of the gallery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She raced through the empty back chamber. “Who is there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frustration arose. She turned, jamming the gun into her waistband again, reaching with both hands for the oil painting. To her shock, it did not budge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t hanging on the wall by a wire; it was nailed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She jerked on it again. It did not move.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And that was when she heard a lock clicking loudly in the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She whirled to face the front door, expecting to see someone standing there, grinning at her. Instead, she saw a flash of movement outside of the gallery as someone ran up the steps to the sidewalk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She cried out. Francesca ran to the door and seized it—but it was locked from outside as she had expected.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She cried out again, furiously, and tugged on the doorknob again. It did not budge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stunned, she stood there, the knob in her hands, the horror beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had just been locked in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How was she going to get out? How was she going to get to her wedding?")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ALDER")]), _vm._v(" H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ART STARED OUT")]), _vm._v(" of the window of the Fifth Avenue Presbyterian Church’s second-floor lounge, feeling very pleased. He was already in his tuxedo, although ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("he had yet to don his tie. Fifth Avenue was deserted. Everyone who was anyone had left town for the summer—except, of course, for those at the uppermost crust of New York society who lived in awe—or fear—of Julia Van Wyck Cahill.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The avenue was terribly attractive this way, in such a state of splendid desolation, with only a single carriage and two black hansoms traversing its paved streets. Stately mansions, elegant townhomes, exclusive shops and clubs lined the thoroughfare. Only three coaches were parked outside the church; it was far too early for guests to arrive. He glanced at a grandfather clock in one corner of the dressing room. It was a few minutes past 3:00 p.m. His gaze wandered back outside. Surely he wasn’t looking for his bride—he was not superstitious, but he had no wish to see her before the wedding, just in case. He smiled to himself. He had little doubt that Francesca was already in the church with her sister and mother, frantically applying the finishing touches to her toilette, as if she could possibly be made any more beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A few months ago, if someone had told him he would be at a wedding as the groom, he would have been very amused—and he would have considered that person an absolute fool. Yet there he was, with a racing heart and a touch of nerves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, Calder,” Rourke Bragg said, laughter in his quiet tone. “Are you planning a mad dash for the exit yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took one last look at the quiet avenue. Two roundsmen in blue serge, carrying billy sticks, were standing on the street corner, chatting. Hart suspected they would soon be directing traffic.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("He slowly turned to face the young man who had spoken. Rourke took after his father, Rathe Bragg. He was tall and broad-shouldered, with golden hair, amber eyes and a sun-kissed, almost swarthy, complexion. He ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("also had Rathe’s inherently sunny, optimistic nature. He was actually Rick’s half brother, but having been taken in by the Bragg family at the age of nine, when their mother died, Hart considered him a relation, if not a sibling of sorts.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He also happened to like Rourke, who was in medical school and was devoted to his profession. He had not one hypocritical bone in his body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Speaking of hypocrites, Rick Bragg had yet to arrive. He had only spent a half an hour last night with them at the private room they had taken in the Sherry Netherland to celebrate the last of Hart’s bachelor days. Hart smiled grimly. He rarely bested his perfect brother. He had surely bested him now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He would never forget that once, months ago, Rick had been smitten with his bride. But Francesca was marrying "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The satisfaction welled. It was savage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He must be sweating bullets,” Rourke’s younger brother, Gregory, said. He was twenty years old to Rourke’s twenty-four, and currently clerking in San Francisco for his uncle, Brett D’Archand, a shipping magnate. Upon learning of the wedding, he had taken a train to New York. Hart had asked Rourke, Gregory and their younger brother, Hugh, to stand up with him, along with young Nick D’Archand. Gregory’s grin was smug. “My God, Hart, it’s all over after today. No more wild women, no more fantastic orgies, just shackles and chains. You must be mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart slowly smiled. “If you are asking me if I have doubts, the answer is no.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("Everyone in the room turned to look at him. The only male in the wedding party who was not present was the father of the bride. Andrew Cahill was downstairs, pacing in the front hall. Hart knew he would meet every single ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("guest personally. “It must be love,” Hugh Bragg snickered. He’d arrived from Texas two days earlier.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart was adept at ignoring conversations he wished to ignore, and he said, unperturbed, “I am marrying the most interesting woman on this planet. Need I say more?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca’s brother, Evan Cahill, smiled. “Even the mighty fall,” he murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Like I said…” Hugh laughed, reaching for a flute of champagne.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was only fifteen, and his father adroitly removed the flute before he could take a sip. Scowling, Hugh accepted a root beer from Alfred instead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart meant his every word. He had no doubts. He had realized, within days of meeting Francesca, that she was the most extraordinary of women. She was as brave as she was beautiful. Her intellect was astounding and she had more ambition than most men he knew. She was all that was good, pure and honest in the world, and he worried, because she was so trusting. He had never known anyone more selfless or more generous. She had shown him, time and again, that she could not turn her back on anyone in need.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was also independent. Most men would hate her refusal to be subservient and obedient; he admired her willful, libertarian nature.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, she was reckless and impulsive; no one had less common sense. But now that he knew how easily she leaped in front of runaway trains, he would be there to restrain her from her poor judgment. She had already caused him to grow a gray hair or two—and they had only known one another for five months.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("He had first glimpsed her in Rick’s office on January 25, but he hadn’t spoken to her until an outrageous party on the rooftop of Madison Square Garden on January 31. By February 23, he had known that she was the one ")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("woman in this world who would never bore him. He had looked at her, realizing how much her friendship had come to mean to him, his heart lurching oddly. She had changed his world in a handful of days, and while he thought the human aspiration to acquire happiness incredibly trite, she had warmed his entire life. The decision made in an instant, he had abruptly informed her that he intended to take her to wife. Needless to say, Francesca had been in shock.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had accepted his suit five days later.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was almost impossible to believe that they had come this far. But he wanted to marry Francesca Cahill, and he always got what he wanted. No one acquired the wealth and assets that he had, coming from such stark and impoverished beginnings, without sheer will and unholy ambition.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was even eager for their wedding night, although he tried to feign indifference, even nonchalance. He was so used to casually seducing the beautiful women that crossed his path that it had become a game of sorts. He hadn’t wanted to treat her like the others. Francesca, he intended to treat with respect. He had decided that he would not take her innocence until they had said their vows.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had a moment of hesitation, almost a frisson of fear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She thought him noble. That was her most astounding feature—her unshakable faith in him. She simply did not understand that he was motivated by self-interest—always. If he were truly noble, he’d tell her to find someone worthy of her—someone like Rick. But he would never do such a thing. She was his first and only friend. His best friend. Of course, he must have her entirely for himself.")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She refused to see him as he truly was, and sometimes, that terrified him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One day, he knew his world would implode—when she realized the truth about him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And as he had that unhappy thought, the lounge door opened and Rick Bragg walked into the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart stared at his brother, who had given up all the finer things in life to pursue justice, equality and liberty for all. He despised his virtuous half brother, but he recognized that Rick was as selfless as Hart was selfish, a noble do-gooder. He truly wished to save the world, and it was not a show. Yet Rick was not the perfect gentleman, no matter how he might pretend to be. He had flesh-and-blood needs and dark desires, just like anyone else. Sometimes, Hart could not stand Rick’s attempt to cling to his moral code. When it crumbled, Hart thrilled. Unfortunately, those moments were rare. As unfortunately, the world needed men like Rick Bragg, just as it needed women like Francesca. Otherwise, the world would be a living hell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He just wished that Rick were not his half brother. He was good, Hart was bad. He was loved, Hart was not. Rick was the insider, the wanted one; no matter his wealth and power, Hart was always the outsider.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mostly, he hated the fact that Rick had seen, courted, kissed and loved Francesca first.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick looked grim. Hart did not smile now. Rick was perfect for Francesca. They were exactly alike—two radical, reforming, saintly peas in a pod. He had always thought that they were perfect for one another. But Francesca had chosen him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tensed. “Hello, Rick. I really didn’t think you would come.” He had won this battle. He might as well relish the fact.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick did not smile in return. “I debated declining.”")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He approached, feeling predatory. He was not a hypocrite; he had not asked Rick to stand up with him. “And what, pray tell, changed your mind? Surely you do not wish to celebrate my union with Francesca?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I saw Francesca this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart started. He did not like being taken by surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She remains dazzled by you. But then, you know as well as I do that she is trusting and naive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His fists clenched involuntarily. “She came to see you?” Why would she go to Rick on the morning of their wedding? Oh, he knew why!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick stared. Finally, slowly, he smiled. “No, Calder, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" went to see her. I wanted to persuade her to delay the wedding. I am afraid for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He inhaled. For one moment, he had been blinded with jealousy; for one moment, he had thought that Francesca had doubts. “I am going to take care of her—in every possible way.” He let the ugly innuendo hang.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick flushed. He lowered his voice and said, “And for a while, she will be even more smitten, won’t she? But one day, passion will not be enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart wanted to tell him to get out. But within half an hour, he would be exchanging vows with his bride and he wanted Rick there, suffering through it—as jealous as he himself had just been.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You know I am right. You broke it off with her after Daisy was murdered, to protect her from yourself. You should do the right thing now. Call off the wedding.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("Hart smiled, and it felt ugly. He had broken their engagement when he had been arrested for his mistress’s death. He hadn’t wanted her ruined by association with him. He would never be able to live with himself if he brought her down that way. “I am not under arrest now. I am not in jail. I am not a suspect in a murder. In fact, what I am is one of the country’s wealthiest millionaires.” ")]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("He couldn’t help thinking that Rick was acting as if he still loved the woman Hart was about to marry. His half brother had been detoured by the return of his wife and his lust for her, but lust wasn’t love and it did not last for very long. Besides, Rick was no fool. The blinders were clearly coming off. Leigh Anne was as weak and selfish as Francesca was strong and good. Sooner or later, he would realize the mistake he had made—if he hadn’t already realized it.")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He continued viciously. “I am going to give Francesca the life she deserves—a life of intellectual freedom, with all the power she needs to do as she wishes, when she wishes. Nothing and no one will stop me, and certainly not you. In a few more moments, we will stand before Reverend Cramer and exchange our vows to become man and wife. Tonight I will consummate that union, and no man—not even you, Rick—will be able to come between us. In a few more days, we will be on our way to Paris on our honeymoon. Did you know I bought the vessel that will transport us across the Atlantic?” They would be its only passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick flushed. “Lust isn’t love. And you don’t have a clue as to what the latter is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you do?” Hart mocked. “Is the lovely Leigh Anne downstairs—or upstairs, in your bedroom?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rathe came to stand between them. “I cannot believe that the two of you are carrying on the way you did as small boys!” He glared at Hart. “You are provoking him, when you know he has strong feelings for Francesca.” He glared at Rick. “You are married, and your wife deserves more. Today is Calder’s wedding day—for better or for worse!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am afraid for her,” Rick said, not even looking at Rathe. “He will destroy her, either slowly or in one fell swoop.” He turned on his heel to leave.")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Rick. Don’t bother to attend the ceremony,” Hart said softly, furious now. Rick was wrong. He would never hurt Francesca. He just hoped his black past wouldn’t ruin them, as it had almost done so recently.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick turned back to face him. “I apologize. I gave Francesca my blessings this morning, and I meant it. I want her to be happy. That means I want both of you to have a successful marriage. I am hoping you will be a good and devoted husband.” He flushed again. Clearly, the words pained him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart raised his brows, incredulous. “You are giving me your blessings?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Unlike you, I prefer taking the high road.” Rick stared, his expression hard and tight. “I am trying, no matter how difficult you make it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart had to laugh. “Of course you are—you are so damn noble!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rourke shoved a scotch at him. “Drink it. He has apologized, and you should bury the hatchet, at least for the rest of the day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart took the scotch, but did not bother to take a sip. He was utterly amused. Only Rick would sincerely offer him his blessings. He wondered how noble his brother would be later that night, after he and Francesca had gone home to finally and thoroughly make love to one another. He hoped Rick would stay awake, brooding unhappily about it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A knock sounded on the lounge door and Gregory went to open it. The moment Hart glimpsed Julia’s starkly white face, with Connie standing behind her fearfully, his heart turned over with sickening force. He glanced again at the grandfather clock. It was 3:30 p.m.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Julia?” Rathe hurried forward. Hart saw Rathe’s wife, Grace, standing with Julia—her arm around her, as if she might collapse.")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know where she is!” Julia cried. “Francesca isn’t here, she isn’t at the house, and no one has seen her since noon!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart felt the room still. All conversation ceased. Time stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Francesca wasn’t there.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course she wasn’t. There wasn’t going to be a wedding—and he wasn’t even truly surprised. She had come to her senses at last.")])])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page46"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88745412","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426887703_ch02.vue
// module id = 78
// module chunks = 0